import {customAxios} from "../customAxios";
import {useState} from "react";

export function useEnableMultiImport() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    async function execute(importId: number) {
        try {
            setLoading(true);
            setError(undefined);
            await enableMultiImport(importId);
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, error, execute
    };
}

export async function enableMultiImport(importId: number): Promise<void> {
    const response = await customAxios.put<void>(`/v1/lease-packages/import/multi/${importId}`, );
    return response.data;
}

export function useDisableMultiImport() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    async function execute(importId: number) {
        try {
            setLoading(true);
            setError(undefined);
            await disableMultiImport(importId);
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, error, execute
    };
}

export async function disableMultiImport(importId: number): Promise<void> {
    const response = await customAxios.delete<void>(`/v1/lease-packages/import/multi/${importId}`, );
    return response.data;
}

